import { Injectable } from '@angular/core';
import { ConstantsService } from './constants.service';

@Injectable()
export class AppSettingsService {

  constructor(
    private constants: ConstantsService
  ) { }

  private sizeUnits = this.constants.SizeUnit.FT;
  private ceilingHeight = this.constants.wallHeight;
  private wallNodeMove: boolean = true;
  private activeStep = 0;
  private isProjectSaved: boolean = false;
  private isProjectTemplate: boolean = false;
  private isProjectLocked: boolean = false;
  private reviewId = null;
  private scenery = 'grid';
  private _is2D: boolean = true;
  
  public get is2D() : boolean {
    return this._is2D;
  }
  
  public set is2D(v : boolean) {
    this._is2D = v;
  }
  
  setSizeUnits(u) {
    this.sizeUnits = u;
  }

  getSizeUnits() {
    return this.sizeUnits;
  }

  getCeilingHeight() {
    return this.ceilingHeight || this.constants.wallHeight;
  }

  setCeilingHeight(val) {
    this.ceilingHeight = val;
  }

  setWallNodeMove(val) {
    this.wallNodeMove = val;
  }

  getWallNodeMove() {
    return this.wallNodeMove;
  }

  getActiveStep() {
    return this.activeStep;
  }

  setActiveStep(val) {
    this.activeStep = val;
  }

  getIsProjectSaved() {
    return this.isProjectSaved;
  }

  setIsProjectSaved(val) {
    this.isProjectSaved = val;
  }

  getIsProjectTemplate() {
    return this.isProjectTemplate;
  }

  setIsProjectTemplate(val) {
    this.isProjectTemplate = val;
  }

  getIsProjectLocked() {
    return this.isProjectLocked;
  }

  setIsProjectLocked(val) {
    this.isProjectLocked = val;
  }

  setReviewId(val) {
    this.reviewId = val;
  }

  getReviewId() {
    return this.reviewId;
  }

  setScenery(value: string) {
    this.scenery = value;
  }

  getScenery() {
    return this.scenery;
  }

}





// WEBPACK FOOTER //
// ./src/app/services/app-settings.service.ts